import { useGetWorkbenchData } from "../queries/useGetWorkbenchData";
import { CSTDateFormatterWithTime_12_hr } from "../utils/DateFormatter";

export const useWorkbenchData = ({body, config}) => {
    const {data,isLoading, isFetching, isError, error,refetch} = useGetWorkbenchData({body, config});
    
    if(data!== null && data!== undefined){
        var i =0, len = data['gridData'].length;
        while(i<len){
            data['gridData'][i]['SLA_COMPLIANCE'] = CSTDateFormatterWithTime_12_hr(data['gridData'][i]['SLA_COMPLIANCE'],"workbench");
            data['gridData'][i]['LOAD_DATE'] = CSTDateFormatterWithTime_12_hr(data['gridData'][i]['LOAD_DATE']);
            data['gridData'][i]['TECHNICIAN_ASSIGNED_DATE_TIME'] = CSTDateFormatterWithTime_12_hr(data['gridData'][i]['TECHNICIAN_ASSIGNED_DATE_TIME']);
            data['gridData'][i]['LAST_UPDATED_DATETIME'] = CSTDateFormatterWithTime_12_hr(data['gridData'][i]['LAST_UPDATED_DATETIME'])
            i++;
        }
    }
    return { data ,isLoading, isFetching , isError, error, refetch};
}